module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "collapse-wrap"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4e17149e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/collapse/Collapse.vue
// module id = 338
// module chunks = 0